// Parse time durations from text (e.g., "5 minutes", "10 mins", "2 hours")
export function parseTimeDurations(text) {
  const durations = [];
  
  // Patterns to match various time formats
  const patterns = [
    /(\d+)\s*(hour|hours|hr|hrs)/gi,
    /(\d+)\s*(minute|minutes|min|mins)/gi,
    /(\d+)\s*(second|seconds|sec|secs)/gi,
  ];
  
  patterns.forEach(pattern => {
    let match;
    while ((match = pattern.exec(text)) !== null) {
      const duration = parseInt(match[1]);
      const unit = match[2].toLowerCase();
      
      // Convert to seconds
      let seconds = 0;
      if (unit.startsWith('hour') || unit.startsWith('hr')) {
        seconds = duration * 3600;
      } else if (unit.startsWith('min')) {
        seconds = duration * 60;
      } else if (unit.startsWith('sec')) {
        seconds = duration;
      }
      
      if (seconds > 0) {
        durations.push({
          duration: seconds,
          unit: formatTimeUnit(duration, unit),
          text: match[0]
        });
      }
    }
  });
  
  return durations;
}

function formatTimeUnit(duration, unit) {
  if (unit.startsWith('hour') || unit.startsWith('hr')) {
    return duration === 1 ? 'hour' : 'hours';
  } else if (unit.startsWith('min')) {
    return duration === 1 ? 'minute' : 'minutes';
  } else if (unit.startsWith('sec')) {
    return duration === 1 ? 'second' : 'seconds';
  }
  return unit;
}

export function formatTimeRemaining(seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  
  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  } else if (minutes > 0) {
    return `${minutes}:${secs.toString().padStart(2, '0')}`;
  } else {
    return `0:${secs.toString().padStart(2, '0')}`;
  }
}
